import { Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/pro-solid-svg-icons";
import type { SelectOption } from "./types";

export interface SelectOptionsEditorProps {
  value: SelectOption[];
  onChange: (next: SelectOption[]) => void;
}

export const SelectOptionsEditor = ({
  value,
  onChange,
}: SelectOptionsEditorProps): JSX.Element => {
  const update = (i: number, patch: Partial<SelectOption>) =>
    onChange(value.map((o, idx) => (idx === i ? { ...o, ...patch } : o)));

  const setDefault = (i: number) =>
    onChange(value.map((o, idx) => ({ ...o, default: idx === i })));

  const remove = (i: number) => onChange(value.filter((_, idx) => idx !== i));

  const add = () =>
    onChange([...value, { key: "", value: "", default: false }]);

  return (
    <div className="select-options-editor">
      <Form.Label>Options</Form.Label>
      <small className="text-muted d-block mb-1">
        Add predefined values the user can choose from. Rows with no name are
        ignored.
      </small>
      <table className="table table-sm">
        <thead>
          <tr>
            <th>Name of Option</th>
            <th>Value</th>
            <th>Default</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {value.map((opt, i) => (
            <tr key={i}>
              <td>
                <Form.Control
                  aria-label={`option-key-${i}`}
                  value={opt.key}
                  onChange={(e) => update(i, { key: e.target.value })}
                />
              </td>
              <td>
                <Form.Control
                  aria-label={`option-value-${i}`}
                  value={opt.value}
                  onChange={(e) => update(i, { value: e.target.value })}
                />
              </td>
              <td className="text-center">
                <Form.Check
                  type="checkbox"
                  aria-label={`option-default-${i}`}
                  checked={opt.default}
                  onChange={() => setDefault(i)}
                />
              </td>
              <td>
                <Button
                  variant="link"
                  className="text-danger p-0"
                  aria-label={`remove-option-${i}`}
                  onClick={() => remove(i)}
                >
                  <FontAwesomeIcon icon={faTrashCan} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Button variant="link" className="p-0" onClick={add}>
        Add option
      </Button>
    </div>
  );
};

export default SelectOptionsEditor;
